<template>
  <div class="login">
    <div class="contain">
      <div class = "header">
        <div class="yellowCircleContain">
          <div class="yellowCircle"></div>
        </div><p class = "title">欢迎进入</p>
        <div class="redCircleContain">
          <div class="redCircle"></div>
        </div>
        <p class = "session">5G+VR红色教育云平台</p>
      </div>
      <div class="form">
        <div class="item">
          <van-field>
            <template #left-icon>
              <div class="icons">
                <div :class="['line',uNameFocus?'red':'gray']"></div>
                <div class="img">
                  <van-icon :name="require('@/assets/images/home/k12_charc.png')" />
                </div>
              </div>
            </template>
            <template #input>
              <input v-model="username" placeholder="账号" @focus="onFocus('username')" @blur="onBlur('username')"/>
            </template>
          </van-field>
        </div>
        <div class="item item2">
          <van-field>
            <template #left-icon>
              <div class="icons">
                <div :class="['line',pwdFocus?'red':'gray']"></div>
                <div class="img">
                  <van-icon :name="require('@/assets/images/home/k12_lock.png')" />
                </div>
              </div>
            </template>
            <template #input>
              <input type="password" v-model="password" placeholder="密码" @focus="onFocus('password')" @blur="onBlur('password')"/>
            </template>
          </van-field>
        </div>
        <div @click="submit()" class="buttom">登录</div>
      </div>
    </div>
    <img class = "bottom_image" :src="require('@/assets/images/home/k12_login_icon.png')"/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',
      uNameFocus: true,
      pwdFocus: false
    }
  },
  methods: {
    onFocus (flag) {
      switch (flag) {
        case 'username': {
          this.pwdFocus = false
          this.uNameFocus = true
          break
        }
        case 'password': {
          this.uNameFocus = false
          this.pwdFocus = true
          break
        }
      }
    },
    onBlur (flag) {
      switch (flag) {
        case 'username': {
          this.uNameFocus = false
          break
        }
        case 'password': {
          this.pwdFocus = false
          break
        }
      }
    },
    submit () {
      if (!this.username.trim()) {
        this.$toast('用户名不能为空！')
        return
      }
      if (!this.password.trim()) {
        this.$toast('密码不能为空！')
        return
      }
      const body = {
        username: this.username,
        password: this.password
      //  password: md5(this.password)
      }
      this.$store.dispatch('Login', body).then((res) => {
        this.$toast('登录成功')
        // this.$router.replace('/home')
        this.$store.dispatch('GetTabList').then((result) => {
          if (result.length) {
            this.$router.replace(result[0].appName)
          } else {
            this.$toast('该账号尚无菜单权限，请联系管理员！')
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login{
  height: 100%;
  position: relative;
  overflow-y: scroll;
  .contain{
    height: calc(100% - 150px);
    padding-bottom: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
  }
  .header{
    padding: 68px 53px 48px 53px;
    .yellowCircleContain{
      position: relative;
      width: 100%;
      height: 47px;
      .yellowCircle{
        width: 47px;
        height: 47px;
        opacity: 1;
        background: radial-gradient(#ffe802 0%, #fdb701 100%);
        box-shadow: 6px 10px 15px 2px rgba(225,161,3,0.25), 0px 0px 0px NaNpx rgba(225,160,3,0.22) inset;
        border-radius: 50%;
        position: absolute;
        right: 31px;
      }
    }
    .redCircleContain{
      position: relative;
      width: 100%;
      height: 20px;
      .redCircle{
        width: 20px;
        height: 20px;
        opacity: 1;
        background: radial-gradient(#f37c7d 0%, #d12e2f 100%);
        box-shadow: 2px 3px 16px 1px rgba(209,45,47,0.30), 0px 0px 0px NaNpx #d7473f inset;
        border-radius: 50%;
        position: absolute;
        right: 7px;
      }
    }
    .title{
      height: 24px;
      opacity: 1;
      font-size: 24px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: left;
      color: #252525;
      line-height: 24px;
    }
    .session{
      height: 13px;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: left;
      color: #999999;
      line-height: 13px;
      letter-spacing: 0px;
    }
  }
  .form{
    padding: 0 53px;
    .item{
      margin-bottom: 20px;
      .icons{
        display: flex;
        justify-content: space-around;
      }
      .line{
        display: block;
        width: 3px;
        height: 40px;
        opacity: 1;
        border-radius: 2px 0px 0px 2px;
      }
      .red{
        background: #bd3133;
      }
      .gray{
        background: #f5f5f5;
      }
      .img{
        line-height: 40px;
        margin: 0 14px 0 18px;
        img{
          width: 17px;
          height: 18px;
        }
      }
      input{
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-width: 0;
        margin: 0;
        padding: 0;
        background-color: transparent;
        border: 0;
        resize: none;
        opacity: 1;
        font-size: 15px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        letter-spacing: 0px;
      }
    }
    .item2{
      margin-bottom: 40px;
    }
    .buttom{
      width: 100%;
      height: 40px;
      opacity: 1;
      background: #d12e2f;
      border-radius: 2px;
      opacity: 1;
      font-size: 15px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 40px;
      letter-spacing: 0px;
    }
  }
  .bottom_image{
    position: fixed;
    width: 100%;
    height: 150px;
    bottom:0;
  }
}
</style>
<style lang="scss">
.login{
  .van-cell {
    padding: 0;
    background-color: #f5f5f5;
    line-height: 40px;
  }
}
</style>
